import moment from "moment-mini";
import { Linking } from "react-native";

import { store } from "../../store/store";
import { onAppLoad, initialiseAppDataAPI } from "./webapp-services/OnAppLoadInitializer";
import { isIOS, isMacOs, isSafari } from "react-device-detect";

import { doPost as apiDoPost } from "./api/API";

import { trackMoengageEvents } from "./webapp-services/MoengageUtils";

import { DeeplinkDataSubscription, orderListSubscriptionForOrderSummary, UserSavedAddressSubscription } from "./subject-behaviour/CommonRxjsService";
import { resetRedux, updateGuestToken, updateWAOptInState } from "./redux/commonRedux";

import { getMemberIcon } from "./user/GetMemberIcon";
import { updateActivityData } from "./CheckActivityStatus";

import { Categories } from "../constants/econsult/Category";
import { ActivityType, ServiceEndpoints } from "../constants/AppConstants";
import { NavigateFrom, ScreenRoute } from "../constants/ScreenRouteConstant";
import { expiredSubscriptionData, newSubscriptionData, purchasedSubscriptionData } from "../constants/acs/aayuCardMapping";

import * as AlertService from "../../utils/services/AlertLoaderService";

import AppTheme from "../../AppTheme";

function checkAgeRange(ageRange, age) {
    if (ageRange == null) {
        return true;
    } else if (age >= ageRange[0] && age <= ageRange[1]) {
        return true;
    } else return false;
}

function getMemberGender(memberId) {
    var memberGender = 'M'
    const memberList = store.getState().familydetails['familyMembers'];
    memberList.forEach((member) => {
        if (member['id'] == memberId)
            memberGender = member.gender;
    })
    return memberGender;
}

function checkIsIOS() {
    return isIOS || isMacOs || isSafari
}

function fixFileVersion(version, filePath) {
    let split_parts = filePath.split('/images')
    return '/images/' + version + split_parts[1]
}

export function isStandAloneApp() {
    return window.matchMedia('(display-mode: standalone)').matches
}

export function getAppWidth() {
    if (window.innerWidth > 450) {
        return 450;
    } else {
        return window.innerWidth;
    }
}

export function getAppHeight() {
    return window.innerHeight;
}

export function getDeviceWidth() {
    return window.innerWidth;
}

export function getDeviceHeight() {
    return isStandAloneApp() ? window.outerHeight : window.innerHeight;
}

export function constrainOverflowingView() {
    if (window.innerWidth > 450) {
        let overflowWidth = window.innerWidth - 450
        return overflowWidth / 2
    } else return 0
}

export function getImagePath(fileRelPath) {
    if (checkIsIOS())
        fileRelPath = fileRelPath.replace('.webp', '.png')
    else fileRelPath = fileRelPath.replace('.png', '.webp')
    fileRelPath = fixFileVersion('v2', fileRelPath)
    return getResourceRootUrl() + fileRelPath
}

export function checkAlternatePhNumber(alternatePhNum, userPhNum) {
    if (alternatePhNum == null || alternatePhNum == '' || alternatePhNum == 0 || alternatePhNum.length < 10)
        return userPhNum;
    else return alternatePhNum;
}

export function checkAayuSubscriptionValidity(subscriptionData) {
    if (subscriptionData == null || Object.keys(subscriptionData).length == 0) {
        return newSubscriptionData;
    } else if (moment().isBefore(subscriptionData.validTill * 1000) &&
        subscriptionData.maxConsultations - subscriptionData.consultedCount > 0) {
        return purchasedSubscriptionData;
    } else return expiredSubscriptionData;

}

export function checkUserNameLastChar(name) {
    const nameLastIndex = name.length - 1
    if (name[nameLastIndex] == 's' || name[nameLastIndex] == 'S')
        return name + "'";
    else return name + "'s";
}

export function maxStringLength(string = '', length = 20) {
    if (string.length > length - 2) return string.substring(0, length) + '...';
    else return string;
}

export function checkOSPlatform(category) {
    if (checkIsIOS())
        return category.icon_png_url;
    else return category.icon_webp_url;
}

export function getMemberImageURL(memberId) {
    var memberList = [];
    var imageURL: any = null;

    const reduxState = store.getState();
    if (reduxState.familydetails)
        memberList = reduxState['familydetails']['familyMembers'];

    memberList.forEach((member) => {
        if (member['id'] == memberId)
            imageURL = getMemberProfileURL(member);
    })

    if (imageURL)
        return imageURL;
    else return '/images/memberSelection/36-50-Male.svg';
}

export function getMemberProfileURL(memberData) {
    if (isObjectEmpty(memberData)) {
        return getImagePath('/images/profile.png')
    } else if (memberData['url'] && memberData['url'] != '')
        return memberData['url']
    else return getImagePath(getMemberIcon(memberData))
}

export function applyAgeGenderFilter(age, gender, category) {
    if (category.gender == null || category.gender === '') {
        return checkAgeRange(category.ageRange, age);
    } else if (category.gender == gender[0].toUpperCase()) {
        return checkAgeRange(category.ageRange, age);
    } else return false;
}

export function addFontFamilyStyle(config: any) {
    Object.keys(config).forEach((k) => {
        if (!config[k]['fontFamily'])
            config[k]['fontFamily'] = 'Roboto_500Medium';
    });
    return config;
}

export function addFontFamilylato(config: any) {
    Object.keys(config).forEach((k) => {
        if (!config[k]['fontFamily'])
            config[k]['fontFamily'] = 'Lato_400Regular';
    });
    return config;
}

export function getCategoryImageAssetURL(caseCode, memberId) {
    var imageURL = 'Miscellaneous.webp';
    const memberGender = getMemberGender(memberId);
    for (const [, category] of Object.entries(Categories)) {
        if (caseCode == category.cm.en) {
            if (category['gender']) {
                if (category['gender'] === memberGender[0].toUpperCase())
                    imageURL = category.iconAsset;
            } else imageURL = category.iconAsset;
        }
    }
    return imageURL;
}

export function triggerFBQ(eventName, eventParams) {
    // eventParams['test_event_code'] = 'TEST8275';
    window['fbq'](
        'trackCustom',
        eventName,
        eventParams
    )
}
export function downloadPrescription(consultId, serviceType) {
    AlertService.loaderModal.setLoader(true);
    apiDoPost('econsult/get_erx_download_link', {
        'consultationId': consultId,
        'consultationType': serviceType,
        'recordId': ""
    }).then((response: any) => {
        AlertService.loaderModal.setLoader(false);
        Linking.openURL(response?.downloadURL).catch((err) =>
            console.error('An error occured', err));
    }, (err: any) => { console.log("API is failed with error " + err) });
}

export function addActivityType(activityList, type) {
    activityList.forEach((activity) => {
        activity['acType'] = type
    })
    return activityList
}

export function isGuestTokenValid() {
    const _reduxState = store.getState()
    let guestTokenData: any = _reduxState.guestToken
    if (guestTokenData && (guestTokenData?.expiresAt * 1000) > Date.now())
        return true;
    else return false;
}

export function getSelectedLocationTitle(location) {
    let title = 'Select location'
    if (location['isAddressCompleted']) {
        title = location['name']
    } else title = location['locationTitle']
    return title
}

export function logoutAndReset(props) {
    onAppLoad()
    const reduxState = store.getState()
    var guestToken = reduxState.guestToken
    setTimeout(() => resetRedux(), (10))
    setTimeout(() => updateGuestToken(guestToken), (20))
    setTimeout(() => {
        UserSavedAddressSubscription.clearSavedAddress();
        orderListSubscriptionForOrderSummary.clearOrderList();
    }, (20))
    setTimeout(() => {
        props.navigation.replace(ScreenRoute.splash);
        initialiseAppDataAPI();
    }, (50));
}

export const updateOptInState = (waState, updateWAState, activity) => {
    AlertService.loaderModal.setLoader(true);
    var waUpdate = waState.isOpted
    updateWAState({
        optInState: waState.optInState,
        isOpted: !waState.isOpted
    });
    const params = { whatsappOptState: waState.isOpted ? 2 : 1, wsappOtpinFlow: activity }
    apiDoPost('accounts/update_whatsapp_opt_state', params).then(() => {
        updateWAOptInState(waState.isOpted ? 2 : 1)
        AlertService.loaderModal.setLoader(false);
    }, () => {
        updateWAState({
            optInState: waState.optInState,
            isOpted: waUpdate
        })
    })
}

export const setMultipleOptionSelection = (option, index, {
    selectedOption, updateSelectedOption, updateDescription
}) => {
    var exclusiveIndex = -1,
        isOptionAlreadySelected = false,
        toggleViewIndex = selectedOption.toggleViewIndex,
        indexList: any = selectedOption.selectedIndexList,
        optionsList: any = selectedOption.selectedOptions;
    for (var i = 0; i < indexList.length; i++) {
        if (indexList[i] == index) {
            indexList.splice(i, 1);
            optionsList.splice(i, 1);
            isOptionAlreadySelected = true;
            if (option.toggleView) {
                toggleViewIndex = -1
                updateDescription('')
            }
            updateSelectedOption({
                selectedIndexList: indexList,
                selectedOptions: optionsList,
                toggleViewIndex: toggleViewIndex,
                exclusiveIndex: -1
            });
        }
    }
    if (indexList.includes(selectedOption.exclusiveIndex)) {
        indexList.splice(indexList.indexOf(selectedOption.exclusiveIndex), 1);
        optionsList.splice(indexList.indexOf(selectedOption.exclusiveIndex), 1);
    }
    if (!isOptionAlreadySelected) {

        if (option.exclusive) {
            indexList.splice(0, indexList.length);
            optionsList.splice(0, optionsList.length);
            exclusiveIndex = index
        }
        if (option.toggleView)
            toggleViewIndex = index

        indexList.push(index);
        optionsList.push(option);
        updateSelectedOption({
            selectedIndexList: indexList,
            selectedOptions: optionsList,
            toggleViewIndex: toggleViewIndex,
            exclusiveIndex: exclusiveIndex
        });
    };
}

export const setSingleOptionSelection = (option, index, {
    setSelectedOption, setDescription
}) => {
    setSelectedOption({
        index: index,
        option: option,
        toggleView: option.toggleView
    })
    if (!option.toggleView)
        setDescription('')
}

export const computeMaxGenId = (dataList) => {
    var maxGenId = 0
    dataList?.forEach((item) => {
        if (maxGenId < item['gen']) maxGenId = item['gen']
    })
    return maxGenId
}

// Move to appropiate module
export const updateAndMergeActivityData = (oldActivityList, updatedActivityList,
    { activityType = null, mergeKey }) => {
    if (updatedActivityList && updatedActivityList.length) {
        if (activityType) updatedActivityList = addActivityType(updatedActivityList, activityType)
        oldActivityList = mergeUpdatedDataList({
            key: mergeKey, dataList: oldActivityList,
            updatedDataList: updatedActivityList
        })
        var updateList = []
        oldActivityList.forEach((activity) => {
            updateList.push(updateActivityData(activity))
        })
    } else updateList = oldActivityList
    if (updateList && updateList.length)
        return updateList
    else return []
}

// Move to appropiate module
export const mergeUpdatedDataList = ({ dataList, updatedDataList, key }) => {
    if (dataList == null)
        dataList = updatedDataList
    else {
        let l = updatedDataList.length
        let ll = dataList.length
        for (var i = 0; i < l;) {
            var isNewData = true
            for (var j = 0; j < ll;) {
                if (dataList[j][key] === updatedDataList[i][key]) {
                    dataList.splice(j, 1, updatedDataList[i]);
                    isNewData = false
                }
                j = j + 1
            }
            if (isNewData)
                dataList.push(updatedDataList[i])
            i = i + 1
        }
    }
    return dataList
}

export const updateActivityList = (updatedConsultationList) => {
    var activityActiveListLength = updatedConsultationList?.length ?? 0
    var commonList = []
    commonList = updatedConsultationList
    commonList.sort((activity1, activity2) => {
        var timeStamp1 = 0
        var timeStamp2 = 0
        if (activity1['acType'] == ActivityType.order) {
            if (activity1['pharmacyData'] && activity1['pharmacyData']['lpmat'])
                timeStamp1 = activity1['pharmacyData']['lpmat']
            else timeStamp1 = activity1['ts']
        } else timeStamp1 = activity1['createdOn']
        if (activity2['acType'] == ActivityType.order) {
            if (activity2['pharmacyData'] && activity2['pharmacyData']['lpmat'])
                timeStamp2 = activity2['pharmacyData']['lpmat']
            else timeStamp2 = activity2['ts']
        } else timeStamp2 = activity2['createdOn']
        return timeStamp2 - timeStamp1
    })
    return {
        activityList: commonList,
        activityActiveListLenght: activityActiveListLength
    }
}

export const getPrimaryUserData = (familyData: any) => {
    var minUserId = familyData.userId
    var familyMembers = familyData.familyMembers ?? []
    var userData = familyData.userDetails ?? {}
    familyMembers.forEach((member: { id: any; name: any; }) => {
        if (member.id <= minUserId) {
            minUserId = member.id
            userData = member
        }
    });
    var isProfileComplete = false
    var isNameCaptured = false
    if (userData['dob'] != 0 &&
        userData['name'] != '' &&
        userData['name'] != 'N/A' &&
        userData['name'] != 'N/a' &&
        userData['address']) {
        isProfileComplete = true
    }
    if (userData['name'] != '' &&
        userData['name'] != 'N/A' &&
        userData['name'] != 'N/a') {
        isNameCaptured = true
    }
    userData['isProfileComplete'] = isProfileComplete
    userData['isNameCaptured'] = isNameCaptured
    userData['familyId'] = familyData['familyId']
    return userData
}

export const checkRouteNavigateFrom = (props, navigateFrom) => {
    const splitParts = navigateFrom.split(',');
    const navigationRoute = splitParts[0]
    var updatedNavigateTo = '';
    if (navigationRoute === NavigateFrom.payment_online) {
        props.navigation.navigate(ScreenRoute.acs_current_plan, {});
    } else if (navigationRoute === NavigateFrom.econsult_success) {
        props.navigation.navigate(ScreenRoute.econsult_details, { consultationId: splitParts[1] })
    } else if (navigationRoute === NavigateFrom.dashboard_for_econsult) {
        props.navigation.navigate(ScreenRoute.econsult_start, {})
    } else if (navigationRoute == NavigateFrom.order_successful) {
        props.navigation.navigate(ScreenRoute.list_orders, {})
    } else if (navigationRoute == NavigateFrom.view_order_details) {
        props.navigation.navigate(ScreenRoute.list_orders, {})
    } else if (navigationRoute == NavigateFrom.view_order_summary) {
        props.navigation.navigate(ScreenRoute.list_orders, {})
    } else if (navigationRoute == NavigateFrom.oms_order_delivered) {
        props.navigation.navigate(ScreenRoute.list_orders, {})
    } else if (navigationRoute === NavigateFrom.site_store_profile) {
        props.navigation.navigate(ScreenRoute.site_store_profile, { addToFav: true })
    } else if (navigationRoute === NavigateFrom.oms_message_view) {
        props.navigation.navigate(ScreenRoute.oms_message_view, { orderData: { oid: parseInt(splitParts[1]), pharmacyData: { id: parseInt(splitParts[2]) } } })
    } else if (navigationRoute === NavigateFrom.deeplink_message_view) {
        var deeplinkData = {}
        DeeplinkDataSubscription.getDeeplinkData().subscribe((data: any) => {
            deeplinkData = data?.deeplinkData
        })
        props.navigation.navigate(ScreenRoute.oms_message_view, deeplinkData)
    } else if (navigationRoute === NavigateFrom.deeplink_order_summary) {
        var deeplinkData = {}
        DeeplinkDataSubscription.getDeeplinkData().subscribe((data: any) => {
            deeplinkData = data?.deeplinkData
        })
        props.navigation.navigate(ScreenRoute.view_order_summary, deeplinkData)
    }
    // else {props.navigation.navigate(ScreenRoute.list_orders, {})}
    global.navigateFrom = updatedNavigateTo;
}

export function shareAayuOnWhatsapp() {
    trackMoengageEvents('refer_aayu');
    var _link;
    var messageEn = `हेलो! \n👨‍⚕️घर में किसी के भी बीमार होने पर घर बैठे स्पेशलिस्ट डॉक्टर से, *बिना अपॉइंटमेंट लिए फ़ोन पर परामर्श* ले सकते हैं।📞` + `\n` +
        `👨‍👩‍👧‍👦 *आयु कार्ड लेने से* पूरे परिवार को साल भर तक डॉक्टर को दिखाने के लिए मुझे *फीस की कोई चिंता नही* रहती।😇 ` +
        '\n\n' + `मेरी तरह आप भी अपने परिवार को सुरक्षित रखें और इन सभी सेवाओं का फायदा लें।` + '\n' + `👉 इस लिंक को देखें - \n ${window.location.origin}`;
    _link = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(messageEn);
    window.open(_link, '_blank');
}

export function getServerID() {
    const href = window.location.href;
    if (window.location.host.indexOf('.aayu.app') != -1) return "vega";
    else if (__DEV__ && window.location.host == 'lap.mcords.co.in') return "lap";
    else if (__DEV__ && window.location.host == 'medicals.mcords.co.in') return "lap";
    else if (__DEV__) return "npm";
    // else if (__DEV__) return "" || "npm";
    else return window['SERVER_ID']
}

export const isChemistStoreLoaded = () => {
    if (location.host != 'aayu.app' && location.host != 'aayuapp.mcords.co.in' &&
        location.host != 'lap.mcords.co.in') return true
    else return localStorage.getItem('storeProfileLoaded') ? true : false;
}

export function getResourceRootUrl() {
    if (__DEV__) return ServiceEndpoints[getServerID()]['resources']

    if (ServiceEndpoints[getServerID()]['resources'])
        return ServiceEndpoints[getServerID()]['resources']

    return window['RESOURCES_PUBLIC_URL'] + '/assets';
}

export const checkAuthTokenExist = () => {
    const reduxState = store.getState()
    if (reduxState.isUserLogin) {
        return reduxState.userToken.hasOwnProperty('token') && reduxState.userToken['token']
    } else {
        return reduxState.guestToken.hasOwnProperty('token') && reduxState.guestToken['token']
    }
}

export const getBaseHref = function () {
    // const host = window.location.host;
    // if (host == 'aayu.app' || host == 'aayuapp.mcords.co.in' || host.indexOf(':') != -1)
    //     return '/pwa';
    // else
    //     return '';
    return ''
}

export const getIndianNumberingFormat = (number) => {
    // return 99,99,999
    const numberStr = number.toString()
    var index = numberStr.length - 1
    var reverseAmountStr = ''
    var unit = 'below hundered'
    var unitIndex = 0
    while (index >= 0) {
        if (unit == 'below hundered') {
            unitIndex = unitIndex + 1;
            reverseAmountStr = reverseAmountStr + numberStr[index];
            if (unitIndex == 3 && index - 1 >= 0) {
                reverseAmountStr = reverseAmountStr + ','
                unitIndex = 0
                unit = 'above hundered'
            }
        } else {
            unitIndex = unitIndex + 1;
            reverseAmountStr = reverseAmountStr + numberStr[index];
            if (unitIndex == 2 && index - 1 >= 0) {
                reverseAmountStr = reverseAmountStr + ','
                unitIndex = 0
            }
        }
        index = index - 1;
    }
    var splitString = reverseAmountStr.split("")
    var reverseArray = splitString.reverse();
    var joinArray = reverseArray.join("");
    return joinArray;
}

export const isObjectEmpty = (data) => {
    if (data) {
        if (typeof (data) == "object")
            return Object.keys(data).length == 0
        else return true
    } else return true
}

export const isObjectNotEmpty = (data) => {
    if (data && typeof (data) == "object") {
        return Object.keys(data).length != 0
    } else return false
}

export const objectContainAllKeys = (obj, arr) => {
    for (const str of arr) {
        if (Object.keys(obj).includes(str)) continue;
        else return false;
    }
    return true;
};

export const getPluralString = (dataListLength = 1, baseString = 'Item', pluralString = '') => {
    if (!pluralString) pluralString = baseString + 's'
    if (dataListLength == 1) return baseString
    else return pluralString
}

export const getPuralStringWithCount = (dataListLength = 1, baseString = 'Item', pluralString = '') => {
    if (!pluralString) pluralString = baseString + 's'
    if (dataListLength == 1) return '1 ' + baseString
    else return dataListLength + ' ' + pluralString
}

export const getStringWithItemCount = (dataListLength = 1, baseString = 'Item', pluralString = '') => {
    if (!pluralString) pluralString = baseString + 's'
    if (dataListLength == 1) return baseString + '(1)'
    else return pluralString + '(' + dataListLength + ')'
}

export const vibrateDevice = () => {
    const canVibrate = window.navigator.vibrate ?? false
    if (canVibrate) window.navigator.vibrate(AppTheme.deviceVibration)
}

export const cap1stChar = (value) => {
    if (value)
        return value[0].toUpperCase() + value.substring(1)
    else return value
}

export const getNameInitials = (name) => {
    var nameList = name.split(' ')
    var initials = nameList[0].substring(0, 1).toUpperCase();
    if (nameList.length > 1)
        initials += nameList[nameList.length - 1].substring(0, 1).toUpperCase();
    else initials += nameList[0].substring(1, 2).toUpperCase();
    return initials;
}
